const config = process.env.APP_CONFIG;

export const urlCollect = config.urlCollect;
export const urlLogger = config.urlLogger;
export const urlCookieSet = config.urlCookieSet;
export const urlCookieIframe = config.urlCookieIframe;
export const urlSupport = config.urlSupport;
export const urlAllani = config.urlAllani;
export const urlDomodi = config.urlDomodi;
export const cookieDomodiUserId = config.cookieDomodiUserId;
export const cookieDomodiSession = config.cookieDomodiSession;
export const cookieDomodiMessageName = config.cookieDomodiMessageName;
